<template>
    <div v-if="fullData && file_upload_limitation">
        <div class="custom-header mb-8 flex">
            <img
                :src="fullData.profile.avatar"
                alt=""
                :onerror="`this.src='${require('@/assets/images/not-photo.png')}'`"
            />
            <div class="ml-10 flex flex-col">
                <span class="text-lg font-semibold">
                    {{ fullData.profile.last_name }}
                    {{ fullData.profile.first_name }}
                    {{ fullData.profile.middle_name }}
                </span>
                <span>
                    {{
                        $moment(fullData.profile.birth_date).format(
                            "DD MMMM YYYY"
                        )
                    }}
                </span>
                <span>
                    {{ fullData.profile.email }}
                </span>
            </div>
        </div>
        <div class="flex justify-between mb-4 flex-col md:flex-row">
            <div class="w-full mb-4 md:mb-0">
                <multiselect
                    v-model="selectModel"
                    class="w-full custom-multiselect"
                    :placeholder="$t('select_object_for_edit_and_view')"
                    deselectLabel=""
                    selectLabel=""
                    track-by="nameI18n"
                    :custom-label="(obj) => $t(obj.nameI18n)"
                    :selectedLabel="$t('selected')"
                    :options="listObject"
                >
                    <div slot="noOptions">{{ $t("no_data") }}</div>
                    <div slot="noResult">{{ $t("not_search_result") }}</div>
                </multiselect>
            </div>
            <div class="w-full flex justify-between md:justify-end">
                <vs-button
                    color="primary"
                    @click="showModalHistory = true"
                    type="border"
                >
                    {{ $t("show_history") }}
                </vs-button>
                <vs-button
                    type="relief"
                    v-if="rulesEdit"

                    class="ml-4"
                    @click="accessToEdit = !accessToEdit"
                >
                    {{ $t("edit") }}
                </vs-button>
            </div>
        </div>

        <div class="mb-8">
            <component
                :is="getComponentForEdit"
                :disabled="!accessToEdit"
                :file_upload_limitation="file_upload_limitation"
                @setNewDataInObject="setNewDataInObject"
                ref="editingComponent"
                :data="fullData"
            />
            <ActionForApplicant v-if="indexObject === listObject.length - 1" :status_code="fullData.status_code"/>
        </div>

        <div class="flex justify-between">
            <div>
                <vs-button
                    type="border"
                    color="danger"
                    v-if="indexObject !== 0"
                    @click="setIndexObject(null, 'back')"
                >
                    {{ $t("back") }}
                </vs-button>
            </div>
            <div>
                <vs-button
                    type="border"
                    line-origin="center"
                    color="success"
                    v-if="accessToEdit"
                    @click="saveEditingDataObject"
                >
                    {{ $t("save") }}
                </vs-button>
            </div>
            <div>
                <vs-button
                    type="relief"
                    v-if="indexObject !== listObject.length - 1"
                    @click="setIndexObject(null, 'next')"
                >
                    {{ $t("next") }}
                </vs-button>
            </div>
        </div>

        <vs-popup
            color="primary"
            fullscreen
            :active.sync="showModalHistory"
            class="custom-popup"
            :title="$t('history')"
        >
            <history
                v-if="showModalHistory"
                :applicantUid="$route.query.uid"
                :data="listObject[indexObject]"
            />
        </vs-popup>
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import history from "@/pages/Home/CheckApplicationsForModerator/EditAndViewApplicant/components/history";
import vSelect from "vue-select";
import ActionForApplicant from "@/pages/Home/CheckApplicationsForModerator/EditAndViewApplicant/components/ActionForApplicant";
import { mapGetters } from "vuex";
export default {
    name: "Page",
    components: {
        history,
        "v-select": vSelect,
        ActionForApplicant,
    },
    data() {
        return {
            fullData: null,
            indexObject: 0,
            accessToEdit: false,
            showModalHistory: false,
            listObject: [
                {
                    nameI18n: "personal_data",
                    history: ["profile", "identitydocument"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Questionnaire/modules/PersonalData"
                        ),
                },
                {
                    nameI18n: "contacts",
                    history: ["address", "profilephone"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Questionnaire/modules/Contacts"
                        ),
                },
                {
                    nameI18n: "family",
                    history: ["family", "familymember"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Questionnaire/modules/Family"
                        ),
                },
                {
                    nameI18n: "privileges",
                    history: ["privilege"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Questionnaire/modules/Privileges"
                        ),
                },
                {
                    nameI18n: "other",
                    history: ["misc"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Questionnaire/modules/Other"
                        ),
                },
                {
                    nameI18n: "past_education",
                    history: ["education"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/PastEducation"
                        ),
                },
                {
                    nameI18n: "resultTestENTAndKT",
                    history: ["examcertificate", "passedsubject"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/CertificateOfTestENTAndKT"
                        ),
                },
                {
                    nameI18n: "internationalCertificates",
                    history: ["internationalcertificate"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/InternationalCertificates"
                        ),
                },
                {
                    nameI18n: "grant",
                    history: ["grantcertificate"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/Grants"
                        ),
                },
                {
                    nameI18n: "directions_for_training",
                    history: ["direction"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/DirectionOfTraining"
                        ),
                },
                {
                    nameI18n: "additional_documents_title",
                    history: ["extradocument"],
                    object: () =>
                        import(
                            "@/pages/Home/FillingInTheApplicantsData/AdditionalDocuments/Page"
                        ),
                },
            ],
            infoOfApplicant: this.$route.query,
            file_upload_limitation: null,
        };
    },
    computed: {
        getComponentForEdit() {
            return this.listObject[this.indexObject].object;
        },
        selectModel: {
            get() {
                return this.listObject[this.indexObject];
            },
            set(value) {
                this.setIndexObject(value);
            },
        },
        ...mapGetters({
            user: "user/getUser",
        }),
        rulesEdit(){
            if(this.user.role.edit_moderator) return true
            // if(this.user['admissions']['edit']){
            //     if(this.fullData.status_code === 'APPROVED' ){
            //         return false
            //     } else if(this.fullData.status_code === 'REJECTED'){
            //         return false
            //     } else
            //         return true
            // }
            return false

        }
    },
    methods: {
            async getDataApplicant() {
            try {
                this.$vs.loading();

                this.fullData = await (
                    await this.$http.get(`admissions/applicants/data/`, {
                        params: {
                            profile: this.$route.query.profile,
                            event: "start_review",
                        },
                    })
                ).data;
                // Если раскомментить console.log(this.fullData),
                // будет постоянно выводиться ошибка this.$t("check-in_another_moderator")
                // console.log(this.fullData)
                (
                    await this.$http.get(
                        `admissions/applicants/${ this.$route.query.uid }/timeline/`
                    )
                ).data;
            } catch (e) {
                this.$vs.dialog({
                    color: "warning",
                    title: this.$t("access_error"),
                    text: this.$t("check-in_another_moderator"),
                    acceptText: this.$t("ok"),
                    accept: () => {
                        this.$router.go(-1);
                    },
                });
            } finally {
                this.$vs.loading.close();
            }
        },
        async getFileUploadLimitation() {
            try {
                this.file_upload_limitation = (
                    await this.$http.get("common/settings/")
                ).data[0];
            } catch (e) {
            } finally {
            }
        },
        async saveEditingDataObject() {
            try {
                if (await this.$refs["editingComponent"].validateStep()) {
                    await this.$vs.notify({
                        text: this.$t("success_save_data"),
                        color: "success",
                    });
                }
            } catch (e) {
            } finally {
            }
        },
        setIndexObject(object, typeStep) {
            if (object) {
                this.indexObject = this.listObject.findIndex(
                    (e) => e["nameI18n"] === object.nameI18n
                );
            } else {
                this.indexObject =
                    typeStep === "next"
                        ? this.indexObject + 1
                        : this.indexObject - 1;
            }

            this.accessToEdit = false;
        },
        setNewDataInObject({ name, data }) {
            this.fullData[name] = data;
        },
    },
    created() {
        if (this.$route.query.uid) {
            this.getDataApplicant();
            this.getFileUploadLimitation();
        } else {
            this.$router.push({ name: "check-applications-for-moderator" });
        }
    },
    beforeDestroy() {
        this.$http.get(`admissions/applicants/data/`, {
            params: {
                profile: this.infoOfApplicant.profile,
                event: "finish_review",
            },
        });
    },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}
.custom-header {
    img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        box-shadow: 0 0 20px 0px #b3b3b3;
        object-fit: cover;
    }
}

.custom-multiselect::v-deep {
    z-index: 10000;

    .multiselect__placeholder {
        color: rgba(0, 0, 0, 0.4);
    }

    .multiselect__tags {
        //height: 38px;
        //min-height: auto !important;
    }
}
</style>
